import { useCallback } from 'react';

export const ScreenOfDeath = () => {
    const handleReload = useCallback(() => {
        location.reload();
    }, []);

    return (
        <>
            <div className="flex flex-col justify-center items-center min-h-screen">
                <h1 className='text-xl lg:text-4xl text-[#0b111e] mb-6'>Ajaj! Došlo k chybě :(</h1>
                <p className='max-w-[40rem] text-center text-base mb-6'>Omlouváme se za potíže, ale tahle chyba je na nás! Došlo k pádu celé aplikace. Chybu máme zaznamenanou a budeme se jí co nejdříve věnovat.</p>
                <p className='max-w-lg text-center text-md font-medium'>Zkuste prosím <button className='hyperlink' onClick={handleReload}>obnovit stránku</button>. Pokud potíže přetrvávají, kontaktujte prosím podporu na <a href="mailto:info@aikorektury.cz" className='hyperlink'>info@aikorektury.cz</a></p>
            </div>
        </>


    );
};




